<template>
  <q-select
    v-model="user.preferredLanguage"
    :class="{ 'borderless': readOnly }"
    :label="$t('user.preferredLanguage')"
    :options="currentCircuit.supportsTranslations ? currentCircuit.availableLanguagesOptions : [{ label: 'English', value: 'en' }]"
    emit-value
    map-options
    bottom-slots
    color="grey"
    :readonly="readOnly || !currentCircuit.supportsTranslations"
    :rules="[val => !!val || 'Field is required']"
  >
    <slot>
      <q-tooltip
        anchor="top middle"
        self="bottom middle"
      >
        {{ $t('pages.account.preferredLanguageDescription') }}.
      </q-tooltip>
    </slot>
  </q-select>
</template>

<script>
export default {
  name: 'UserPreferredLanguageSelect',
  props: {
    user: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['currentCircuit']
}
</script>
